import { message } from 'antd';
import { formatApiError, getApiErrorMessages } from './apiErrorMessages';

const TOAST_CONFIG = {
  top: 72,
  duration: 4,
  maxCount: 3,
};

let configured = false;

export const configureAppToast = (options = {}) => {
  message.config({
    ...TOAST_CONFIG,
    ...options,
  });
  configured = true;
};

export const syncAppToastDirection = (isRtl) => {
  message.config({
    ...TOAST_CONFIG,
    rtl: Boolean(isRtl),
  });
  configured = true;
};

const show = (type, content) => {
  if (content == null || content === '') {
    return;
  }

  if (!configured) {
    configureAppToast();
  }

  message[type](content);
};

export const appToast = {
  success: (content) => show('success', content),
  error: (content) => show('error', content),
  warning: (content) => show('warning', content),
  info: (content) => show('info', content),
  apiError: (error, fallbackMessage = 'Something went wrong') => {
    const content = error?.formattedMessage ?? formatApiError(error, fallbackMessage);
    show('error', content);
    return getApiErrorMessages(error, fallbackMessage);
  },
};

export default appToast;
